import { render, staticRenderFns } from "./PricingFaq.vue?vue&type=template&id=2b7a5aaf&scoped=true&"
import script from "./PricingFaq.vue?vue&type=script&lang=js&"
export * from "./PricingFaq.vue?vue&type=script&lang=js&"
import style0 from "./PricingFaq.vue?vue&type=style&index=0&id=2b7a5aaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a5aaf",
  null
  
)

export default component.exports